import { z } from 'zod';
import { AnalyticsFieldSearchResponseSchema, AnalyticsFieldSearchSchema } from './fields.js';
import { AnalyticsQueryResponseSchema, AnalyticsQuerySchema } from './query.js';
import { AnalyticsTimestampSchema } from './timestamp.js';
export const FlowBlockDataAnalyticsFieldsRoute = {
    method: 'get',
    fullPath: '/analytics/flow-block-data/fields',
    summary: 'Find fields for exported flow block data',
    description: 'Find dimensions, measures and filter-only fields in the standalone Flow Run Block Data topic. ' +
        'Returns metadata, not payloads. Results may include fields unavailable to the caller.',
    tags: ['Analytics'],
    query: AnalyticsFieldSearchSchema,
    response: AnalyticsFieldSearchResponseSchema,
};
export const FlowBlockDataAnalyticsQueryRoute = {
    method: 'post',
    fullPath: '/analytics/flow-block-data/query',
    summary: 'Query exported flow block data',
    description: 'Analyze exported block outputs, errors and data sizes in the standalone Flow Run Block Data topic. ' +
        'Filters must include a non-negated BETWEEN range on dbt_phi_core__flow_run_block_data.flow_run_created_at ' +
        'with ordered timestamps including Z or an explicit offset, independently of completion or export time. ' +
        'Prefer aggregates unless payload contents are requested. Payloads may contain PHI. ' +
        'Rows appear only after the owning run terminates and its terminal state reaches the replicated mart. ' +
        'Export, replication and backfill progress affect coverage; a missing row does not imply no output.',
    tags: ['Analytics'],
    capabilityTags: ['ResponseCouldIncludePhi'],
    body: AnalyticsQuerySchema.extend({
        filters: z.intersection(AnalyticsQuerySchema.shape.filters.unwrap(), z.object({
            'dbt_phi_core__flow_run_block_data.flow_run_created_at': z
                .strictObject({
                type: z.literal('date'),
                kind: z.literal('BETWEEN'),
                left_side: AnalyticsTimestampSchema.describe('Inclusive owning-run creation instant.'),
                right_side: AnalyticsTimestampSchema.describe('Exclusive owning-run creation instant.'),
                is_negative: z.literal(false).optional(),
            })
                .refine((filter) => Date.parse(filter.left_side) < Date.parse(filter.right_side), {
                message: 'Run-created range end must be after start',
                path: ['right_side'],
            }),
        })),
    }),
    response: AnalyticsQueryResponseSchema,
};
//# sourceMappingURL=flowBlockData.js.map